<template>
<b-container class="card py-4">

  <b-form @submit.stop.prevent="create_location">

    <h3>Contact details</h3>
    <b-form-group label="First name" label-cols="3" invalid-feedback="Must be greater then 2 character">
      <b-form-input v-model="item.contact_first_name" required :state="validate_state('contact_first_name')"></b-form-input>
    </b-form-group>

    <b-form-group label="Last name" label-cols="3" invalid-feedback="Must be greater then 2 character">
      <b-form-input v-model="item.contact_last_name" required :state="validate_state('contact_last_name')"></b-form-input>
    </b-form-group>

    <b-form-group label="Phone" label-cols="3" invalid-feedback="Must be a valid phone number">
      <b-form-input type="tel" v-model="item.contact_phone" required :state="validate_state('contact_phone')"></b-form-input>
    </b-form-group>

    <b-form-group label="Email" label-cols="3" invalid-feedback="Must be a valid email">
      <b-form-input type="email" v-model="item.contact_email" required :state="validate_state('contact_email')"></b-form-input>
    </b-form-group>

    <hr>
    <h3>Buisness details</h3>

    <b-form-group label="Buisness Name" label-cols="3">
      <b-form-input v-model="item.name" required readonly></b-form-input>
    </b-form-group>

    <b-form-group label="Url" label-cols="3">
      <b-form-input v-model="item.url" required readonly></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="Buisiness categories" invalid-feedback="At least one category is required">
      <b-form-tags v-model="value" no-outer-focus class="mb-2" required :state="buisness_category_state">
        <template v-slot="{ tags, disabled, addTag, removeTag }">
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled">{{ tag }}</b-form-tag>
            </li>
          </ul>

          <b-dropdown size="sm" block menu-class="w-100">
            <template v-slot:button-content>Choose buisiness categories</template>
            <b-dropdown-form @submit.stop.prevent="() => {}">
              <b-form-group label-for="tag-search-input" label="Search categories" label-cols-md="auto" class="mb-0" label-size="sm" :description="searchDesc" :disabled="disabled">
                <b-form-input v-model="search" id="tag-search-input" type="search" size="sm" autocomplete="off"></b-form-input>
              </b-form-group>
            </b-dropdown-form>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item-button v-for="option in availableOptions" :key="option.id" @click="onOptionClick({ option, addTag })">
              {{ option.name }}
            </b-dropdown-item-button>
            <b-dropdown-text v-if="availableOptions.length === 0">
              There are no categories available to select
            </b-dropdown-text>
          </b-dropdown>
        </template>
      </b-form-tags>
    </b-form-group>

    <b-form-group label="Employees number" label-cols="3">
      <b-form-input type="number" min="1" max="1000000" v-model="item.employees_number" required></b-form-input>
    </b-form-group>

    <b-form-group label="Year founded" label-cols="3" invalid-feedback="Must be a year">
      <b-form-input v-model="item.start_year" required :state="validate_state('start_year')"></b-form-input>
    </b-form-group>

    <b-form-group label="Brief description" label-cols="3" invalid-feedback="Must be less then 200 characters" description="Less then 200 characters">
      <b-form-textarea v-model="item.brief_description" required :state="validate_state('brief_description')"></b-form-textarea>
    </b-form-group>

    <b-form-group label="Full description" label-cols="3" invalid-feedback="Must be less then 500 character">
      <b-form-textarea v-model="item.full_description" required :state="validate_state('full_description')"></b-form-textarea>
    </b-form-group>

    <hr>
    <h3>Hours</h3>

    <b-row class="text-center mb-2">
      <b-col>

      </b-col>
      <b-col>
        Mon
      </b-col>
      <b-col>
        Tue
      </b-col>
      <b-col>
        Wed
      </b-col>
      <b-col>
        Thu
      </b-col>
      <b-col>
        Fri
      </b-col>
      <b-col>
        Sat
      </b-col>
      <b-col>
        Sun
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        Start
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_mon_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_tue_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_wed_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_thu_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_fri_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_sat_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_sun_start" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        End
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_mon_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_tue_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_wed_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_thu_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_fri_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_sat_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
      <b-col>
        <b-form-timepicker :hide-header="true" :reset-button="true" :minutes-step="5" v-model="item.hours_sun_end" size="sm" locale="en" required placeholder=""></b-form-timepicker>
      </b-col>
    </b-row>


    <hr>
    <h3>Location address</h3>
    <b-form-group label-cols="3" label="Address line 1" invalid-feedback="Must be greater then 4 character">
      <b-form-input v-model="item.address_line_1" required :state="validate_state('address_line_1')"></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="Address line 2">
      <b-form-input v-model="item.address_line_2"></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="City" invalid-feedback="Must be greater then 2 character">
      <b-form-input v-model="item.city" required :state="validate_state('city')"></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="Region" invalid-feedback="Must be greater then 2 character">
      <b-form-input v-model="item.region" required :state="validate_state('region')"></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="Postcode" invalid-feedback="Must a valid UK postcode">
      <b-form-input v-model="item.postcode" required :state="validate_state('postcode')"></b-form-input>
    </b-form-group>

    <b-form-group label-cols="3" label="Country">
      <b-form-input v-model="item.country" readonly></b-form-input>
    </b-form-group>

    <hr>
    <h3>Images</h3>
    <b-form-group label-cols="3" label="Logo">
      <b-overlay :show="uploading_logo">
        <b-form-file @input="upload_logo" v-model="logo_file" accept="image/*" placeholder="Select image..." drop-placeholder="Drop file here..."></b-form-file>
      </b-overlay>
    </b-form-group>
    <b-form-group label-cols="3" label="Image 1">
      <b-overlay :show="uploading_image_1">
      <b-form-file @input="upload_image_1" v-model="image_1_file" accept="image/*" placeholder="Select image..." drop-placeholder="Drop file here..."></b-form-file>
      </b-overlay>
    </b-form-group>
    <b-form-group label-cols="3" label="Image 2">
      <b-overlay :show="uploading_image_2">
      <b-form-file @input="upload_image_2" v-model="image_2_file" accept="image/*" placeholder="Select image..." drop-placeholder="Drop file here..."></b-form-file>
      </b-overlay>
    </b-form-group>
    <b-form-group label-cols="3" label="Image 3">
      <b-overlay :show="uploading_image_3">
      <b-form-file @input="upload_image_3" v-model="image_3_file" accept="image/*" placeholder="Select image..." drop-placeholder="Drop file here..."></b-form-file>
      </b-overlay>
    </b-form-group>

    <h3>Social</h3>
    <b-form-group label-cols="3" label="Facebook url" invalid-feedback="Must be a valid URL">
      <b-form-input v-model="item.facebook_url" :state="validate_state('facebook_url')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols="3" label="Twitter url" invalid-feedback="Must be a valid URL">
      <b-form-input v-model="item.twitter_url" :state="validate_state('twitter_url')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols="3" label="LinkedIn url" invalid-feedback="Must be a valid URL">
      <b-form-input v-model="item.linkedin_url" :state="validate_state('linkedin_url')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols="3" label="Instagram url" invalid-feedback="Must be a valid URL">
      <b-form-input v-model="item.instagram_url" :state="validate_state('instagram_url')"></b-form-input>
    </b-form-group>
    <b-form-group label-cols="3" label="Pinterest url" invalid-feedback="Must be a valid URL">
      <b-form-input v-model="item.pinterest_url" :state="validate_state('pinterest_url')"></b-form-input>
    </b-form-group>

    <!-- TODO extra details -->
    <!-- let campaign_data = {
        'location_id': location_id,
        'campaign_name': 'Le Bernardin Citation Builder',
        'business_name': location_data.name,
        'website_address': location_data.url,
        'campaign_country': location_data.country,
        'campaign_city': location_data.city,
        'campaign_state': location_data.region,
        'business_category_id': location_data['business-category-id'],
        'extra_business_categories_ids': '["604"]',
        'business_categories': '["restaurant", "cafe"]',
        'address1': location_data.address1,
        'address2': location_data.address1,
        'city': location_data.city,
        'region': location_data.region,
        'postcode': location_data.postcode,
        'contact_name': 'Bloggs',
        'contact_firstname': 'Joe',
        'contact_telephone': '+1 212-554-1515',
        'contact_email': 'joe.bloggs@test.com',
        'brief_description': briefDescription,
        'full_description': fullDescription,
        'employees_number': 35,
        'start_year': 1976,
        'working_hours_apply_to_all': 'Y',
        'working_hours_mon_start': '8:00 am',
        'working_hours_mon_end': '10:00 pm',
        'social_profile_links': '{"facebook":"https:\/\/en-gb.facebook.com\/brightlocal\/","twitter":"https:\/\/twitter.com\/bright_local","linkedin":"https:\/\/uk.linkedin.com\/company\/bright-local-seo","instagram":"","pinterest":"https:\/\/www.pinterest.co.uk\/brightlocal\/"}',
      } -->

    <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
  </b-form>

</b-container>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  url
} from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import {
  db
} from '@/main.js'

import api from '@/lib/api.js'

import buisness_categories from "@/assets/business_categories.json"

export default {
  name: 'location_edit',
  mixins: [ItemMixin],
  props: ['user', 'site', 'profile'],
  validations: {
    item: {
      facebook_url: {url},
      twitter_url: {url},
      linkedin_url: {url},
      instagram_url: {url},
      pinterest_url: {url},
      name: {
        required,
        minLength: minLength(3)
      },
      address_line_1: {
        required,
        minLength: minLength(3)
      },
      city: {
        required,
        minLength: minLength(2)
      },
      region: {
        required,
        minLength: minLength(2)
      },
      postcode: {
        required,
        minLength: minLength(4)
      },

      contact_first_name: {
        required,
        minLength: minLength(2)
      },
      contact_last_name: {
        required,
        minLength: minLength(2)
      },
      contact_phone: {
        required,
        minLength: minLength(3)
      },
      contact_email: {
        required,
        minLength: minLength(3)
      },
      brief_description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(200)
      },
      full_description: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(500)
      },
      start_year: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4)
      }
    }
  },
  firestore: function() {
    return {
      _item: db.collection('site').doc(this.$route.params.site_id).collection(this.collection).doc()
    }
  },
  methods: {
    async upload_logo(file) {
      this.uploading_logo = true
      this.item.logo_url = await this.upload_image(file)
      this.uploading_logo = false
    },
    async upload_image_1(file) {
      this.uploading_image_1 = true
      this.item.image_1_url = await this.upload_image(file)
      this.uploading_image_1 = false
    },
    async upload_image_2(file) {
      this.uploading_image_2 = true
      this.item.image_2_url = await this.upload_image(file)
      this.uploading_image_2 = false
    },
    async upload_image_3(file) {
      this.uploading_image_3 = true
      this.item.image_3_url = await this.upload_image(file)
      this.uploading_image_3 = false
    },

    onOptionClick({
      option,
      addTag
    }) {
      addTag(option.name)
      this.search = ''
    },
    async create_location() {
      this.$v.item.$touch()
      if (this.$v.item.$anyError) {
        return
      }

      if (this.uploading_logo || this.uploading_image_1 || this.uploading_image_2 || this.uploading_image_3) {
        alert('Please wait for image upload to complete')
        return
      }

      if (this.item.extra_business_categories_ids.length == 0 || !this.item.buisness_category) {
        alert('Please add at least 2 business_categories')
        return
      }

      this.is_saving = true
      let result = await api.add_location(this.item)
      this.$router.push({name: this.collection, params: {id: result.data}})
      this.is_saving = false
    },
    validate_state(name) {
      const {
        $dirty,
        $error
      } = this.$v.item[name];
      return $dirty ? !$error : null;
    }
  },
  watch: {
    value: function(val) {
      let ids = []

      for (let category of buisness_categories) {
        if (val.indexOf(category.name) > -1) {
          ids.push(category.id)
        }
      }

      if (ids.length > 0) {
        this.item.buisness_category = ids[0]
        this.buisness_category_state = true
      } else {
        this.item.buisness_category = null
        this.buisness_category_state = false
      }

      if (val.length > 1) {
        this.item.extra_business_categories_ids = ids.slice(1)
      } else {
        this.item.extra_business_categories_ids = []
      }
    }
  },
  computed: {
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase()
    },
    availableOptions() {
      const criteria = this.criteria
      // Filter out already selected options
      const options = this.options.filter(opt => this.value.indexOf(opt.name) === -1)
      if (criteria) {
        // Show only options that match criteria
        return options.filter(opt => opt.name.toLowerCase().indexOf(criteria) > -1);
      }
      // Show all options available
      return options
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return 'There are no tags matching your search criteria'
      }
      return ''
    }
  },
  data() {
    return {
      is_saving: false,
      options: buisness_categories,
      search: '',
      value: [],
      buisness_category_state: undefined,
      collection: 'location',
      logo_file: undefined,
      uploading_logo: false,
      uploading_image_1: false,
      uploading_image_2: false,
      uploading_image_3: false,
      image_1_file: undefined,
      image_2_file: undefined,
      image_3_file: undefined,
      item: {
        facebook_url: null,
        twitter_url: null,
        linkedin_url: null,
        instagram_url: null,
        pinterest_url: null,
        logo_url: null,
        image_1_url: null,
        image_2_url: null,
        image_3_url: null,
        site_id: this.$route.params.site_id,
        name: this.site.name,
        url: this.site.domain ? `${this.site.domain}` : `${this.site.id}.netlify.app`,
        buisness_category: null,
        extra_business_categories_ids: [],
        country: 'GBR',
        address_line_1: '',
        address_line_2: '',
        region: '',
        city: '',
        postcode: '',

        employees_number: 1,
        start_year: 2020,
        brief_description: '',
        full_description: '',
        contact_email: this.user.email,
        contact_phone: this.user.phone,
        contact_first_name: this.user.displayName.split(' ')[0],
        contact_last_name: this.user.displayName.split(' ').length > 1 ? this.user.displayName.split(' ')[1] : '',

        hours_mon_start: '09:00:00',
        hours_tue_start: '09:00:00',
        hours_wed_start: '09:00:00',
        hours_thu_start: '09:00:00',
        hours_fri_start: '09:00:00',
        hours_sat_start: '',
        hours_sun_start: '',
        hours_mon_end: '17:00:00',
        hours_tue_end: '17:00:00',
        hours_wed_end: '17:00:00',
        hours_thu_end: '17:00:00',
        hours_fri_end: '17:00:00',
        hours_sat_end: '',
        hours_sun_end: '',
      },
    }
  },
  metaInfo() {
    return {
      title: `${this.collection} create`
    };
  },
}
</script>

<style>

</style>
